import MainController from 'controllers/main';
import InfluencerController from 'controllers/influencer';
import InfluencersController from 'controllers/influencers';
import CityController from 'controllers/city';
import CitiesController from 'controllers/cities';


/**
 * Routes
 *
 * Route can somewhat be regex, appart from using the [] brackets, since they are
 * used for extracting specific values from the url
 *
 * Controller is a controller which should extend from the base controller
 *
 */
export default [
    {
        route: 'index.html',
        controller: MainController
    },
    {
        route: '$',
        controller: MainController
    },
    {
        route: 'influencers',
        controller: InfluencersController
    },
    {
        route: 'influencer/[name]',
        controller: InfluencerController
    },
    {
        route: 'cities',
        controller: CitiesController
    },
    {
        route: 'city/[name]',
        controller: CityController
    }
]



// WEBPACK FOOTER //
// ./routes.js